// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"298":"d371c506","441":"eaed377a","451":"69f85615","664":"b82c54c5","857":"1a0cabb3"}[chunkId] + ".chunk.js";
};